import React from 'react';
import PropTypes from 'prop-types';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './DashboardStub.module.scss';

const LEGACY_VARIANTS = Object.freeze({
  'no-data-available-1.svg': 'bars',
  'no-data-available-2.svg': 'table',
  'no-data-available-3.svg': 'bars',
  'no-data-available-4.svg': 'line',
});

const EmptyIllustration = ({ variant }) => (
  <div className={`${styles.illustration} ${styles[variant]}`} aria-hidden="true">
    {variant === 'bars' && <><i /><i /><i /><i /><i /></>}
    {variant === 'line' && (
      <svg viewBox="0 0 320 104" preserveAspectRatio="none">
        <path d="M8 84 L66 62 L120 72 L176 34 L230 48 L312 16" />
        <circle cx="8" cy="84" r="4" />
        <circle cx="66" cy="62" r="4" />
        <circle cx="120" cy="72" r="4" />
        <circle cx="176" cy="34" r="4" />
        <circle cx="230" cy="48" r="4" />
        <circle cx="312" cy="16" r="4" />
      </svg>
    )}
    {variant === 'donut' && <i />}
    {variant === 'table' && (
      <div className={styles.tableRows}>
        <i><span /><b /></i>
        <i><span /><b /></i>
        <i><span /><b /></i>
      </div>
    )}
  </div>
);

EmptyIllustration.propTypes = {
  variant: PropTypes.oneOf(['bars', 'line', 'donut', 'table']).isRequired,
};

const DashboardStub = ({ imgName, variant, compact, height, messageId }) => {
  const t = useLocalizedMessage();
  const effectiveVariant = variant || LEGACY_VARIANTS[imgName] || 'bars';
  return (
    <div
      className={`${styles.root} ${compact ? styles.compact : ''}`}
      style={height ? { minHeight: height } : undefined}
      role="img"
      aria-label={t('dashboard.empty.ariaLabel')}
      data-empty-variant={effectiveVariant}
    >
      <EmptyIllustration variant={effectiveVariant} />
      <p><IntlMessages id={messageId} /></p>
    </div>
  );
};

DashboardStub.propTypes = {
  imgName: PropTypes.string,
  variant: PropTypes.oneOf(['bars', 'line', 'donut', 'table']),
  compact: PropTypes.bool,
  height: PropTypes.number,
  messageId: PropTypes.string,
};

DashboardStub.defaultProps = {
  imgName: null,
  variant: null,
  compact: false,
  height: null,
  messageId: 'search.health.preview.noData',
};

export default DashboardStub;
